import React from 'react';
import PropTypes from 'prop-types';

import contractPage from '../../../hoc/contractPage/contractPage';
import ContractTemplate from '../patterns/ContractTemplate/ContractTemplate';

export const CompliancePolicy = ({ pageContent }) => (
  <ContractTemplate title="Política de Compliance">
    {/* eslint-disable-next-line react/no-danger */}
    <div dangerouslySetInnerHTML={{ __html: pageContent }} />
  </ContractTemplate>
);

CompliancePolicy.propTypes = {
  pageContent: PropTypes.string.isRequired,
};
export default contractPage(CompliancePolicy, {
  routeKey: 'COMPLIANCE_POLICY',
  googleDocumentId: '1EWSJv4TCPu-fKNrjMRrqHAm7De9IyvjkQI7RK0Esb04',
});
